import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import { colorUtils } from 'src/mixins/colors-utils';
import { dialog } from 'src/boot/mixins.js';
import TagList from 'src/store/models/TagList';
export default {
  mixins: [dialog, colorUtils],
  props: {
    confirmTagLists: {
      type: Function,
      default: function _default() {}
    }
  },
  components: {
    TeDialog: TeDialog
  },
  data: function data() {
    return {
      tagLists: [],
      allSelected: false,
      textFilter: null
    };
  },
  computed: {
    filteredTagLists: function filteredTagLists() {
      var _this = this;

      if (!this.textFilter) return this.tagLists;
      return this.tagLists.filter(function (tagList) {
        return tagList.name.toLowerCase().replace(/ /g, '').indexOf(_this.textFilter.toLowerCase().replace(/ /g, '')) >= 0;
      });
    }
  },
  methods: {
    onSelectAll: function onSelectAll(value) {
      this.tagLists.forEach(function (tagList) {
        if (!tagList.disabled) {
          tagList.selected = value;
        }
      });
    },
    onConfirm: function onConfirm() {
      var selectedLists = this.tagLists.filter(function (tagList) {
        return tagList.selected;
      });
      this.confirmTagLists(selectedLists);
      this.hide();
    },
    loadPresets: function loadPresets() {
      var _this2 = this;

      this.tagLists = [{
        selected: false,
        name: this.$t('tag_lists.marketing'),
        tags: [{
          name: this.$t('tag_lists.seo')
        }, {
          name: this.$t('tag_lists.adv')
        }, {
          name: this.$t('tag_lists.social')
        }]
      }, {
        selected: false,
        name: this.$t('tag_lists.finance'),
        tags: [{
          name: this.$t('tag_lists.budgeting')
        }, {
          name: this.$t('general.billing')
        }, {
          name: this.$t('tag_lists.investing')
        }]
      }, {
        selected: false,
        name: this.$t('tag_lists.design'),
        tags: [{
          name: this.$t('tag_lists.wireframes')
        }, {
          name: this.$t('tag_lists.ideas')
        }, {
          name: this.$t('components.dialogs.feedback')
        }]
      }, {
        selected: false,
        name: this.$t('tag_lists.it'),
        tags: [{
          name: this.$t('tag_lists.bugfix')
        }, {
          name: this.$t('tag_lists.dev')
        }, {
          name: this.$t('tag_lists.training')
        }]
      }, {
        selected: false,
        name: this.$t('tag_lists.internal_communication'),
        tags: [{
          name: this.$t('tag_lists.meeting')
        }, {
          name: this.$t('tag_lists.calls')
        }, {
          name: this.$tc('general.e_mail', 1)
        }]
      }, {
        selected: false,
        name: this.$t('tag_lists.support'),
        tags: [{
          name: this.$t('tag_lists.complaints')
        }, {
          name: this.$t('tag_lists.review')
        }, {
          name: this.$t('tag_lists.issues')
        }]
      }, {
        selected: false,
        name: this.$t('tag_lists.customer_service'),
        tags: [{
          name: this.$t('tag_lists.ticketing')
        }, {
          name: this.$t('tag_lists.chat')
        }, {
          name: this.$t('tag_lists.technical_support')
        }]
      }, {
        selected: false,
        name: this.$t('tag_lists.hr'),
        tags: [{
          name: this.$t('tag_lists.talent_acquisition')
        }, {
          name: this.$t('tag_lists.onboarding')
        }, {
          name: this.$t('tag_lists.payroll')
        }]
      }].map(function (tagList) {
        var myTagList = TagList.query().where('name', tagList.name).first();

        var color = _this2.getRandomColor();

        return _objectSpread(_objectSpread({}, tagList), {}, {
          disabled: !!myTagList,
          color: color,
          text_color: _this2.textColorFromBackground(color)
        });
      });
    }
  },
  created: function created() {
    this.loadPresets();
  }
};